module.exports = __webpack_public_path__ + "public/Icons/MapMarker/stopMarker.png?5e890757";